import React from 'react';
import { FaChartLine, FaEnvelope, FaUser, FaRegFileAlt, FaGlobeAmericas } from 'react-icons/fa';
import './HighlightsReasons.css';

const HighlightsReasons = () => {
  const reasons = [
    {
      id: 1,
      icon: <FaChartLine size={28} />,
      title: "Track the latest trends",
      desc: "Gain an edge with the freshest insights on fast-evolving energy and commodity markets."
    },
    {
      id: 2,
      icon: <FaEnvelope size={28} />,
      title: "Free email updates",
      desc: "Get expert analysis, market-moving news, thought leadership and price trends, all delivered direct to your inbox."
    },
    {
      id: 3,
      icon: <FaUser size={28} />,
      title: "Tailored to you",
      desc: "Choose from a wide range of energy and commodity markets that are most relevant to your interests."
    },
    {
      id: 4,
      icon: <FaRegFileAlt size={28} />,
      title: "Content in the format you want",
      desc: "We offer a wide range of complimentary news stories, blog posts, insight papers, podcasts, videos, infographics and more."
    },
    {
      id: 5,
      icon: <FaGlobeAmericas size={28} />,
      title: "Coverage across commodity markets",
      desc: "Provenance Market Highlights offer the latest insight and analysis on many of the most active commodity markets."
    }
  ];

  return (
    <section className="reasons-section">
      <div className="container">
        <div className="reasons-header">
          <h2>Why subscribe to Provenance Market Highlights?</h2>
        </div>

        <div className="reasons-container">
          {reasons.map((item) => (
            <div key={item.id} className="reason-card">
              <div className="reason-icon-wrapper">
                <div className="reason-icon-circle">
                  {item.icon}
                </div>
              </div>
              <h3>{item.title}</h3>
              <p>{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HighlightsReasons;